import React, { useState } from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider
} from '@mui/material';
import {
  Help as HelpIcon,
  Article as ArticleIcon,
  QuestionAnswer as QAIcon,
  Support as SupportIcon,
  Phone as PhoneIcon,
  Computer as ComputerIcon,
  MedicalServices as MedicalServicesIcon,
  AccessTime as AccessTimeIcon
} from '@mui/icons-material';
import HelpModal from '../Help/HelpModal';

const HelpCard = () => {
  const [helpModalOpen, setHelpModalOpen] = useState(false);
  const [helpType, setHelpType] = useState('leave-guide');

  const openHelp = (type) => {
    setHelpType(type);
    setHelpModalOpen(true);
  };

  const helpItems = [
    {
      icon: <ArticleIcon />,
      title: 'Leave Request Guide',
      description: 'How to create and manage leave requests',
      action: () => openHelp('leave-guide')
    },
    {
      icon: <MedicalServicesIcon />,
      title: 'Sick Leave Guide',
      description: 'How to report sick leave and upload medical certificates',
      action: () => openHelp('sick-leave-guide')
    },
    {
      icon: <AccessTimeIcon />,
      title: 'Short Absence Guide',
      description: 'How to register short absences (up to 2 hours)',
      action: () => openHelp('short-absence-guide')
    },
    {
      icon: <ComputerIcon />,
      title: 'Equipment Request Guide',
      description: 'How to request and track equipment',
      action: () => openHelp('equipment-guide')
    },
    {
      icon: <QAIcon />,
      title: 'System FAQ',
      description: 'Frequently asked questions',
      action: () => {
        // Future: Open FAQ modal or page
        console.log('FAQ not yet implemented');
      }
    },
    {
      icon: <SupportIcon />,
      title: 'Contact Support',
      description: 'Get help from our support team',
      action: () => {
        // Future: Open contact form or redirect to support
        window.open('mailto:krasi.donchev@inspirit.bg?subject=HRApp Support Request', '_blank');
      }
    }
  ];

  return (
    <>
      <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <CardContent sx={{ flexGrow: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <HelpIcon color="primary" sx={{ mr: 1 }} />
            <Typography variant="h6" component="h2">
              Help & Support
            </Typography>
          </Box>
          
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Get help with using the HRApp system and find answers to common questions.
          </Typography>

          <List dense>
            {helpItems.map((item, index) => (
              <React.Fragment key={index}>
                <ListItem 
                  button 
                  onClick={item.action}
                  sx={{ 
                    borderRadius: 1,
                    '&:hover': {
                      backgroundColor: 'action.hover'
                    }
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.title}
                    secondary={item.description}
                    primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }}
                    secondaryTypographyProps={{ variant: 'caption' }}
                  />
                </ListItem>
                {index < helpItems.length - 1 && <Divider variant="inset" component="li" />}
              </React.Fragment>
            ))}
          </List>
        </CardContent>

        <Divider />

        <CardActions sx={{ p: 2, pt: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
            <PhoneIcon fontSize="small" color="action" />
            <Typography variant="caption" color="text.secondary">
              Emergency: Contact your manager directly
            </Typography>
          </Box>
        </CardActions>
      </Card>

      <HelpModal
        open={helpModalOpen}
        onClose={() => setHelpModalOpen(false)}
        helpType={helpType}
      />
    </>
  );
};

export default HelpCard;
